import * as z from "zod";

export const disconnectTemuIntegration = {
  name: "disconnectTemuIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
